import React from "react";
import "./Checkbox.styles.scss";
import { CheckOutlined } from "@ant-design/icons";

interface CheckboxProps {
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  children: React.ReactNode;
  size?: "sm" | "md" | "lg";
}

const Checkbox: React.FC<CheckboxProps> = ({ checked, onChange, children, size = "md" }) => {
    const sizeMap = {
        sm: 16,
        md: 20,
        lg: 24,
    };
    const sizeStyle = {
        width: sizeMap[size],
        height: sizeMap[size],
    };
  return (
    <div className="checkbox-container">
      <button
        className={`checkbox-input ${checked ? "checked" : ""}`}
        style={sizeStyle}
        onClick={() =>
          onChange({
            target: { checked: !checked },
          } as React.ChangeEvent<HTMLInputElement>)
        }
      >
        {checked && <CheckOutlined className="checkbox-icon"/>}
      </button>
      <span className="checkbox-label">{children}</span>
    </div>
  );
};

export default Checkbox;
